import axios from 'axios';

import { RESTSERVICES_BASE_URL } from './constants';

export const AUTHORIZE_URL = `${RESTSERVICES_BASE_URL}/authorize`;
export const authorize = async () => {
  const data = await axios
    .post<{ authToken: string }>(AUTHORIZE_URL)
    .then((res) => res.data.authToken);

  return data;
};
